'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.search = exports.writeHash = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* global window history URL */

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @private
 */
var writeHash = exports.writeHash = function writeHash() {
  var slideIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var fragmentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  window.location.hash = '#!/' + slideIndex + '/' + fragmentIndex + '/';
};

/**
 * @public
 */
var search = exports.search = {
  parse: function parse(url) {
    var _ref = new URL(url),
        _ref$search = _ref.search,
        search = _ref$search === undefined ? '' : _ref$search;

    var parts = search.split(/[?&]/).filter(Boolean);
    return parts.reduce(function (a, b) {
      var _b$split = b.split('='),
          _b$split2 = _slicedToArray(_b$split, 2),
          key = _b$split2[0],
          value = _b$split2[1];

      return _extends({}, a, _defineProperty({}, key, value === 'false' ? false : isNaN(value) ? value : Number(value)));
    }, {});
  },
  write: function write(data) {
    var oldQuery = search.parse(window.location.href);
    var newQuery = _extends({}, oldQuery, data);
    var queryString = Object.entries(newQuery).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          k = _ref3[0],
          v = _ref3[1];

      return k + '=' + v;
    }).join('&');
    history.pushState(newQuery, 'searchQuery', '?' + queryString);
  }
};

/**
 * @public
 * @param {Object} props
 *   The properties
 * @param {String} [props.type='hash']
 *   Either `hash` or `query` to enable hash(bang) or search query URLs
 * @param {number} props.slideIndex
 *   (Injected via Dekk)
 * @param {number} props.fragmentCount
 *   (Injected via Dekk)
 * @param {number} props.fragmentIndex
 *   (Injected via Dekk)
 * @param {number} props.fragmentOrder
 *   (Injected via Dekk)
 * @param {function} props.toFragment
 *   (Injected via Dekk)
 * @param {function} props.toSlide
 *   (Injected via Dekk)
 * @param {function} props.toNextFragment
 *   (Injected via Dekk)
 * @param {function} props.toPrevFragment
 *   (Injected via Dekk)
 * @param {function} props.toNextSlide
 *   (Injected via Dekk)
 * @param {function} props.toPrevSlide
 *   (Injected via Dekk)
 * @example
 * import Deck, {Plugins} from '@dekk/deck'
 * import Url from '@dekk/url'
 *
 * export default (
 *   <Deck>
 *     <Plugins>
 *       <Url/>
 *     </Plugins>
 *   </Deck>
 * )
 */

var Url = function (_Component) {
  _inherits(Url, _Component);

  function Url() {
    _classCallCheck(this, Url);

    return _possibleConstructorReturn(this, (Url.__proto__ || Object.getPrototypeOf(Url)).apply(this, arguments));
  }

  _createClass(Url, [{
    key: 'componentDidMount',


    /**
     * @private
     */
    value: function componentDidMount() {
      this[this.props.type](window.location.href);
    }

    /**
     * @private
     */

  }, {
    key: 'hash',
    value: function hash(url) {
      var _ref4 = new URL(url),
          _ref4$hash = _ref4.hash,
          hash = _ref4$hash === undefined ? '' : _ref4$hash;

      var _hash$split = hash.split('/'),
          _hash$split2 = _slicedToArray(_hash$split, 3),
          _hash$split2$ = _hash$split2[1],
          slideIndex = _hash$split2$ === undefined ? 0 : _hash$split2$,
          _hash$split2$2 = _hash$split2[2],
          fragmentIndex = _hash$split2$2 === undefined ? 0 : _hash$split2$2;

      this.toSlide(slideIndex);
      this.toFragment(fragmentIndex);
    }

    /**
     * @private
     */

  }, {
    key: 'query',
    value: function query(url) {
      var _ref5 = new URL(url),
          _ref5$search = _ref5.search,
          search = _ref5$search === undefined ? '' : _ref5$search;

      var parts = search.split(/[?&]/).filter(Boolean);

      var _parts$reduce = parts.reduce(function (a, b) {
        var _b$split3 = b.split('='),
            _b$split4 = _slicedToArray(_b$split3, 2),
            key = _b$split4[0],
            value = _b$split4[1];

        return _extends({}, a, _defineProperty({}, key, value));
      }, {}),
          _parts$reduce$page = _parts$reduce.page,
          slideIndex = _parts$reduce$page === undefined ? 0 : _parts$reduce$page,
          _parts$reduce$fragmen = _parts$reduce.fragment,
          fragmentIndex = _parts$reduce$fragmen === undefined ? 0 : _parts$reduce$fragmen;

      this.toSlide(slideIndex);
      this.toFragment(fragmentIndex);
    }

    /**
     * @private
     */

  }, {
    key: 'toFragment',
    value: function toFragment(fragmentIndex) {
      this.props.toFragment(parseInt(fragmentIndex, 10));
    }

    /**
     * @private
     */

  }, {
    key: 'toSlide',
    value: function toSlide(slideIndex) {
      this.props.toSlide(parseInt(slideIndex, 10));
    }

    /**
     * @private
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref6) {
      var slideIndex = _ref6.slideIndex,
          fragmentIndex = _ref6.fragmentIndex;

      switch (this.props.type) {
        case 'hash':
          writeHash(slideIndex, fragmentIndex);
          break;
        case 'query':
          search.write({ page: slideIndex, fragment: fragmentIndex });
          break;
        default:
          break;
      }
    }

    /**
     * @private
     */

  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'propTypes',

    /**
     * @private
     */
    get: function get() {
      return {
        type: _propTypes2.default.oneOf(['hash', 'query']),
        slideIndex: _propTypes2.default.number,
        fragmentIndex: _propTypes2.default.number,
        toFragment: _propTypes2.default.func,
        toSlide: _propTypes2.default.func
      };
    }

    /**
     * @private
     */

  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        type: 'hash',
        slideIndex: 0,
        fragmentIndex: 0,
        toFragment: function toFragment() {
          return null;
        },
        toSlide: function toSlide() {
          return null;
        }
      };
    }
  }]);

  return Url;
}(_react.Component);

exports.default = Url;
//# sourceMappingURL=index.js.map